import { ArrowUpRightIcon, PlayIcon } from 'lucide-react';
import { HeadingText } from '../shared/HeadingText';
import { usePages } from '../../contexts/SiteContext';
import { shopLabels } from '../../data/shopLabels';
import { fill } from '../../utils/copy';
import { sectionHeading } from '../../ui/sections';

/**
 * Podcastblok onder het journal, op klei: intro, onderwerpen en de afleveringen (extern).
 * Op klei alleen vol `text-shell` (5,6:1); blush alleen voor het grote accent in de kop.
 */
export function JournalPodcast() {
  const pages = usePages();
  const copy = pages.journal;
  const podcastUrl = copy.podcast.url;
  return <section className="bg-clay py-20 text-shell sm:py-24 lg:py-32" aria-labelledby="podcast-title" data-id="element-7661" data-mp="y3hmffb7oblh">
      <div className="mx-auto grid max-w-content gap-12 px-6 lg:grid-cols-12 lg:gap-16 lg:px-10" data-id="element-7662" data-mp="134nerc0ylwuh">
        <div className="lg:col-span-5" data-id="element-7663" data-mp="29imrur2q8o8s">
          {copy.podcast.eyebrow && <p className="text-[14px] text-shell" data-id="element-7664" data-mp="2eiivgp7iidnt">{fill(copy.podcast.eyebrow)}</p>}
          <h2 id="podcast-title" className={`mt-5 ${sectionHeading}`} data-id="element-7665" data-mp="2eklutzuk1j57">
            <HeadingText heading={copy.podcast.heading} accentClassName="text-blush" data-id="element-7666" data-mp="6xl6xg9geket" />
          </h2>
          {copy.podcast.body && <p className="mt-7 max-w-md text-[17px] leading-relaxed text-shell" data-id="element-7667" data-mp="1x772li0agrv">{fill(copy.podcast.body)}</p>}
          <ul className="mt-7 flex flex-wrap gap-2" aria-label="Onderwerpen" data-id="element-7668" data-mp="3u4nfsbz2nvcp">
            {copy.podcast.topics.map(t => <li key={t} className="rounded-full border border-shell/40 px-3 py-1 text-[13px] text-shell" data-id="element-7669" data-mp="3k56gccaeydp6">
                {t}
              </li>)}
          </ul>
          {copy.podcast.cta && <a href={podcastUrl} target="_blank" rel="noreferrer" className="mt-9 inline-flex min-h-[52px] items-center gap-2 rounded-full bg-shell px-7 text-[15px] text-ink transition-colors duration-150 ease-soft hover:bg-blush" data-id="element-7670" data-mp="3ae1woz9sm4o0">
              {fill(copy.podcast.cta)}
              <span className="sr-only" data-id="element-7671" data-mp="2wh5bbdcg1fei"> {shopLabels.newTab}</span>
              <ArrowUpRightIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-7672" data-mp="2mqez0vrsae6y" />
            </a>}
        </div>
        <ul className="divide-y divide-shell/25 border-y border-shell/25 lg:col-span-7" aria-label="Afleveringen" data-id="element-7673" data-mp="2rruf09f3tuih">
          {copy.episodes.map(e => <li key={e.number} data-id="element-7674" data-mp="2hrk5aysa3582">
              <a href={podcastUrl} target="_blank" rel="noreferrer" className="group grid w-full gap-3 py-7 text-left sm:grid-cols-12 sm:items-center sm:gap-6" data-id="element-7675" data-mp="2hslr9yau1c4k">
                <span className="flex items-center gap-4 sm:col-span-5" data-id="element-7676" data-mp="2vsedbgbez467">
                  <span aria-hidden="true" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-shell/50 transition-colors duration-150 ease-soft group-hover:bg-shell group-hover:text-ink" data-id="element-7677" data-mp="2vq1yhc0yd9xd">
                    <PlayIcon className="h-3 w-3 fill-current" strokeWidth={1.5} data-id="element-7678" data-mp="3t8tn7gvrdp79" />
                  </span>
                  <span data-id="element-7679" data-mp="1hqgnt8ubvd8i">
                    <span className="sr-only" data-id="element-7680" data-mp="1ctq8inqcklo5">Beluister </span>
                    <span className="block font-display text-[1.4rem] font-light leading-snug" data-id="element-7681" data-mp="1ct6qz84lzzan">{e.title}</span>
                    <span className="mt-0.5 block text-[13px] text-shell" data-id="element-7682" data-mp="1rkfk3r7q02sj">
                      Afl. {e.number} · {e.duration}
                    </span>
                  </span>
                </span>
                <span className="text-[15px] leading-relaxed text-shell sm:col-span-7" data-id="element-7683" data-mp="yvrytvmz1dez">{e.summary}</span>
                <span className="sr-only" data-id="element-7684" data-mp="twxgsvwtvsvx">{shopLabels.newTab}</span>
              </a>
            </li>)}
        </ul>
      </div>
    </section>;
}